import axios from 'axios';
function obtenerAjustes() {
  return axios.get("/obtener_ajustes")
    .then((response) => {
      if (response.data) {
        return response.data;
      } else {
        throw new Error(response.data.status);
      }
    })
    .catch((error) => {
      throw error;
    });
}
function actualizarAjustes(ajustes) {
  return axios.post("/actualizar_ajustes", ajustes)
    .then((response) => {
      if (response.data) {
        return response.data;
      } else {
        throw new Error(response.data.status);
      }
    })
    .catch((error) => {
      throw error;
    });
}

export async function xgetAllCourses() {
  try {
    const response = await axios.get('/getallcourses');
    
    if (response.data.status === 'success') {
      return response.data.data; // Retorna los datos de los cursos
    } else {
      throw new Error('Error al obtener los cursos');
    }
  } catch (error) {
    return { status: 'fail', error: error.message };
  }
}
export async function createCourse(formData) {
  try {
    const response = await axios.post('/createcourse', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  } catch (error) {
    return { status: 'fail', error };
  }
}
function testget(form) {
  return axios.get("/testget", {params: {form:form} })
    .then((response) => {
      if (response.data) {
        return response.data.status;
      } else {
        throw new Error(response.data.status);
      }
    })
    .catch((error) => {
      throw error;
    });
}
function testpost(form) {
  return axios.post("/testpost",{params: {form:form} })
    .then((response) => {
      if (response.data) {
        return response.data.status
      } else {
        throw new Error(response.data.status);
      }
    })
    .catch((error) => {
      throw error;
    });
}
export {obtenerAjustes, actualizarAjustes, testget, testpost};
